import { lazyImport } from '../../Utils/Loading/loadingHelpers'

export const ExpandMoreIcon = lazyImport(
  () =>
    import(/* webpackChunkName: "mui-icon-expand-more" */ '@mui/icons-material/ExpandMore')
)
export const NotificationsIcon = lazyImport(
  () =>
    import(
      /* webpackChunkName: "mui-icon-notifications" */ '@mui/icons-material/Notifications'
    )
)
export const IosShareIcon = lazyImport(
  () =>
    import(/* webpackChunkName: "mui-icon-ios-share" */ '@mui/icons-material/IosShare')
)
export const InputAdornment = lazyImport(
  () =>
    import(/* webpackChunkName: "mui-icon-input-adornment" */ '@mui/material/InputAdornment')
)
export const PollIcon = lazyImport(
  () => import(/* webpackChunkName: "mui-icon-poll" */ '@mui/icons-material/Poll')
)
export const LockIcon = lazyImport(
  () => import(/* webpackChunkName: "mui-icon-lock" */ '@mui/icons-material/Lock')
)
export const MailOutlineIcon = lazyImport(
  () =>
    import(
      /* webpackChunkName: "mui-icon-mail-outline" */ '@mui/icons-material/MailOutline'
    )
)
export const AlternateEmailIcon = lazyImport(
  () =>
    import(
      /* webpackChunkName: "mui-icon-alternate-email" */ '@mui/icons-material/AlternateEmail'
    )
)
export const CalendarRoundedIcon = lazyImport(
  () =>
    import(
      /* webpackChunkName: "mui-icon-calendar-today-rounded" */ '@mui/icons-material/CalendarTodayRounded'
    )
)

// ARROWS //
export const KeyboardArrowRightIcon = lazyImport(
  () =>
    import(
      /* webpackChunkName: "mui-icon-keyboard-arrow-right" */ '@mui/icons-material/KeyboardArrowRight'
    )
)
export const KeyboardArrowDownIcon = lazyImport(
  () =>
    import(
      /* webpackChunkName: "mui-icon-keyboard-arrow-down" */ '@mui/icons-material/KeyboardArrowDown'
    )
)
export const KeyboardArrowUpIcon = lazyImport(
  () =>
    import(
    /* webpackChunkName: "mui-icon-keyboard-arrow-up" */ '@mui/icons-material/KeyboardArrowUp'
    )
)
// SOCIAL //
export const GoogleIcon = lazyImport(
  () => import(/* webpackChunkName: "mui-icon-google" */ '@mui/icons-material/Google')
)

// CHART //
export const LineChartIcon = lazyImport(
  () =>
    import(/* webpackChunkName: "mui-icon-show-chart" */ '@mui/icons-material/ShowChart')
)

// MAP //
export const MapRoundedIcon = lazyImport(
  () =>
    import(/* webpackChunkName: "mui-icon-map-rounded" */ '@mui/icons-material/MapRounded')
)
